import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"
import * as Klaro from 'klaro/dist/klaro-no-css'
import ScrollTo from "stimulus-scroll-to"
import Carousel from "stimulus-carousel"
import AnimatedNumber from "stimulus-animated-number"
import { Dropdown } from 'bootstrap';
import { Modal } from "bootstrap";
import { Collapse } from 'bootstrap';
import AOS from 'aos';
import { hasLanguageCookie } from './utils/language_gate';

let application = null

if (module.hot) {
  module.hot.accept() // tell hmr to accept updates

  if (module.hot.data) {
    application = module.hot.data.application // re-use old application if one was passed after update
  }
}

if (!application) {
  application = Application.start() // if no application so far, start it
}

if (module.hot) {
  module.hot.dispose(data => {
    data.application = application // on disposal of the old version (before reload), pass the old application to the new version
  })
}

const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
application.register("scroll-to", ScrollTo)
application.register("carousel", Carousel)
application.register("animated-number", AnimatedNumber)

AOS.init()

var klaroConfig = {
  storageMethod: 'cookie',
  cookieExpiresAfterDays: 365,
  privacyPolicy: {
    default: '/de-at/weitere-daten/datenschutz/',
    en: '/en/more-data/data-protection/',
    fr: '/fr/plus-dinformations/protection-des-donnees/'
  },
  hideDeclineAll: true,
  acceptAll: true,
  groupByPurpose: false,
  mustConsent: true,
  translations: {
    de: {
      ok: 'Allen zustimmen',
      acceptSelected: 'Auswahl speichern',
      consentModal: {
        title: 'Cookies, die wir speichern',
        description: 'Hier können Sie einsehen und anpassen, welche Informationen gespeichert werden.',
      },
      consentNotice: {
        description: 'Wir verwenden Cookies! Für einen optimalen Service auf unserer Website verwenden wir Cookies für folgende Zwecke: {purposes}. Sie können die Nutzung aller Cookies akzeptieren oder Ihre Auswahl individuell einstellen.',
        learnMore: 'Individuell einstellen'
      },
      gtm: {
        description: 'Sammeln von Besucherstatistiken und für Online-Marketing. Umfasst Google Tag Manager und Google Analytics inklusive der Übermittlung der Daten in Drittländer außerhalb der EU.',
      },
      facebook: {
        description: 'Sammeln von Besucherstatistiken und für Online-Marketing. Umfasst Facebook Pixel inklusive der Übermittlung der Daten in Drittländer außerhalb der EU.',
      },
      salesviewer: {
        description: 'Sammeln von Besucherstatistiken und für Online-Marketing.',
      },
      purposes: {
        analytics: 'Besucher-Statistiken und Online-Marketing',
      },
    },
    en: {
      consentModal: {
        description: 'Here you can see and customize the information that we collect about you.',
      },
      gtm: {
        description: 'Collecting of visitor statistics. Includes Google Tag Manager, Google Analytics and Facebook Pixel',
      },
      facebook: {
        description: 'Collecting of visitor statistics. Includes Facebook Pixel',
      },
      purposes: {
        analytics: 'Analytics',
      },
    },
    fr: {
      ok: 'Autoriser tous les cookies',
      acceptAll: "Accepter tout",
      acceptSelected: "Accepter sélectionné",
      consentNotice: {
        description: 'Bonjour ! Pourrions-nous activer des services supplémentaires pour nos {purposes} ?',
      },
      gtm: {
        description: 'Collecte de statistiques sur les visiteurs. Inclut Google Tag Manager, Google Analytics',
      },
      facebook: {
        description: 'Collecte de statistiques sur les visiteurs. Inclut Facebook Pixel',
      },
      purposes: {
        analytics: 'Statistiques',
      },
      salesviewer: {
        description: 'Collecte de statistiques sur les visiteurs.',
      },
    }
  },

  services: [
    {
      name: 'gtm',
      title: 'Google Tag Manager',
      purposes: ['analytics'],
      cookies: [
        /^_gat_UA-.*$/,
        /^_gat_gtag_.*$/,
        /^_dc_gtm_.*$/,
        '_ga',
        '_gid',
        '_gat',
      ],
    },
    {
      name: 'facebook',
      title: 'Facebook',
      purposes: ['analytics'],
      cookies: [
        '_fbp',
      ],
    },
    {
      name: 'youtube',
      purposes: ['content'],
    },
  ],
};

const countryCode = document.documentElement.getAttribute('data-country');

if (countryCode === 'de') {
  klaroConfig.privacyPolicy.default = '/de-de/weitere-daten/datenschutz/';
  klaroConfig.cookieName = 'klaro_de';

  klaroConfig.services.push({
    name: 'salesviewer',
    title: 'Salesviewer',
    purposes: ['analytics'],
    cookies: [],
  });

  klaroConfig.services.push({
    name: 'bwtjobs',
    title: 'BWT Jobs',
    purposes: ['content'],
    cookies: [],
  });
}

if (document.documentElement.lang === 'fr' && countryCode === 'ch') {
  klaroConfig.privacyPolicy.fr = '/fr-ch/plus-dinformations/protection-des-donnees/';
}

if (document.documentElement.lang === 'de' && countryCode === 'ch') {
  klaroConfig.privacyPolicy.default = '/de-ch/weitere-daten/datenschutz/';
}

if (countryCode === 'ch') {
  klaroConfig.cookieName = 'klaro_ch';

  klaroConfig.services.push({
    name: 'salesviewer',
    title: 'Salesviewer',
    purposes: ['analytics'],
    cookies: [],
  });

  klaroConfig.services.push({
    name: 'klimafoerderrechner',
    title: 'Klimaförderrechner',
    purposes: ['content'],
    cookies: [],
  });

  klaroConfig.services.push({
    name: 'bwtjobs',
    title: 'BWT Jobs',
    purposes: ['content'],
    cookies: [],
  });
}

// Selection.html loads this bundle as <script async> in <head>, where <body> may not exist
// yet. On normal pages it is a footer include and this runs immediately.
function domReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

domReady(() => {
  if (document.body.classList.contains('disable-klaro')) {
    return;
  }

  // klaroConfig has mustConsent, so Klaro would otherwise throw up its own blocking dialog on
  // load - on top of the country chooser. Hold it back until the country question is settled,
  // which is also the correct order: the choice determines which klaroConfig (cookieName,
  // privacyPolicy) the next page builds.
  //
  // Defer only when the dialog itself is on the page and will actually open. The same
  // controller is also attached to the header language switcher and to the root interstitial,
  // which never open a dialog and so would never release Klaro again - matching those would
  // silently kill the consent banner on the academy site, where the modal is gated off.
  const modal = document.querySelector('.modal[data-controller~="language"]');
  const deferKlaro = modal !== null && !hasLanguageCookie();

  klaroConfig.noAutoLoad = deferKlaro;
  window.klaro = Klaro;
  window.klaroConfig = klaroConfig;
  Klaro.setup(klaroConfig);

  if (deferKlaro) {
    let released = false;
    window.releaseKlaro = () => {
      if (released) {
        return;
      }
      released = true;
      // render(), not show(): show() forces the dialog open even for a visitor who has already
      // consented. render(config, {}) reproduces exactly what noAutoLoad suppressed.
      Klaro.render(window.klaroConfig, {});
    };
  }
});

